<template>
    <div class="lateral_menu_wrapper">
        <div class="lat1">
            <span class="block1">
                <a @click="
                    selectedMenuItem({ hasView: true, value: 'dashboard' })
                    ">
                    <img class="unex_logo" src="img/logo_unex_negative.svg" alt="logo" />
                </a>
                <nav class="lateral_menu_nav">
                    <a @click="selectedMenuItem(item)" v-for="(item, index) in App.filterInCurrentView(
                        App.lateral_menu_items,
                        App.root_activated_view
                    )" :key="index" :class="item.value">
                        <i :class="item.icon"></i>
                        <span v-if="item.tooltip == 'language'" class="tooltip_language">{{ App.selected_language }}</span>
                        <span v-if="item.tooltip == 'market'" class="tooltip_language">{{
                            App.entities.markets[App.selected_market_solutions][App.selected_language] }}</span>
                    </a>
                </nav>
            </span>
            <span class="block2">
                <span class="title_unex">{{
                    translations.login_screen.title_app
                }}</span>
                <span class="line gray"></span>
                <a @click="closeSession"><i class="icon-logout"></i></a>
            </span>
        </div>
        <span class="overlay_profile_section" @click="openPanelProfile" v-bind:class="{ active: profile_active }"></span>
        <section class="profile_section" v-bind:class="{ active: profile_active }">
            <span class="wrapper_inputs">
                <header>
                    <p class="title">{{ translations.profile.title }}</p>
                </header>
                <article>
                    <p class="info_section">
                        {{ translations.profile.info_section }}
                    </p>
                    <label class="l_user_data">{{
                        translations.generic.user_label
                    }}</label>
                    <p class="user_data">{{ user.name }}</p>
                    <label class="l_user_email">{{
                        translations.generic.email_label
                    }}</label>
                    <p class="user_data">{{ user.email }}</p>
                    <span class="line_separator"></span>
                    <span class="change_my_password_section">
                        <p class="info_section">
                            {{ translations.profile.change_my_password }}
                        </p>
                        <span class="switcher">
                            <label class="switch">
                                <input class="slide_switch" type="checkbox" v-model="show_change_my_password" />
                                <span class="slider round"></span>
                            </label>
                        </span>
                    </span>
                    <span v-if="show_change_my_password" class="wrapper_change_my_password" v-bind:class="{
                        show_change_my_password: show_change_my_password
                    }">
                        <label>{{
                            translations.generic.current_password_label
                        }}</label>
                        <span class="type_input">
                            <input class="input_type_password" id="password" v-model="password" :placeholder="translations.login_screen
                                        .password_placeholder_profile
                                    " type="password" />
                            <i @click="
                                showPasswordCharts('.input_type_password')
                                " v-bind:class="{ isVisible: password_visible }" class="icon-show-on"></i>
                        </span>
                        <p class="error_input" v-if="errors_profile.email_missing_match">
                            {{
                                translations.generic_errors
                                    .error_update_passwords
                            }}
                        </p>
                        <label>{{
                            translations.generic.new_password_label
                        }}</label>
                        <span class="type_input">
                            <input class="input_type_password" id="new_password" v-model="new_password" :placeholder="translations.login_screen
                                        .password_placeholder_profile
                                    " type="password" />
                            <i @click="
                                showPasswordCharts('.input_type_password')
                                " v-bind:class="{ isVisible: password_visible }" class="icon-show-on"></i>
                        </span>
                        <label>{{
                            translations.generic.repeat_password_label
                        }}</label>
                        <span class="type_input">
                            <input class="input_type_password" id="repeat_new_password" v-model="new_password2"
                                :placeholder="translations.login_screen
                                            .password_placeholder_profile
                                        " type="password" />
                            <i @click="
                                showPasswordCharts('.input_type_password')
                                " v-bind:class="{ isVisible: password_visible }" class="icon-show-on"></i>
                        </span>
                        <p class="error_input" v-if="errors_profile.not_equal_passwords">
                            {{
                                translations.generic_errors.not_equal_passwords
                            }}
                        </p>
                        <p class="error_input" v-if="errors_profile.empty_field">
                            {{ translations.generic_errors.empty_field }}
                        </p>
                        <p class="error_input" v-if="errors_profile.not_correct_format_passwords">
                            {{
                                translations.generic_errors
                                    .not_correct_format_passwords
                            }}
                        </p>
                        <span class="line_separator"></span>
                        <span class="button full_width" @click="updatePassword">{{ translations.profile.password_update
                        }}</span>
                    </span>
                </article>
            </span>
        </section>
        <span class="overlay_query_details_section" @click="openPanelQueryDetails"
            v-bind:class="{ active: query_details_active }"></span>
        <section class="query_details_section" v-bind:class="{ active: query_details_active }">
            <span class="wrapper_inputs">
                <header>
                    <p class="title">{{ translations.details_query.title }}</p>
                </header>
                <article v-if="total_filters_selected > 0" class="filters_selected">
                    <p v-if="App.query.current_query" class="info_section">
                        {{ App.query.current_query.name }}
                    </p>
                    <p v-else class="info_section">
                        {{ translations.details_query.info_section }}
                    </p>
                    <!-- <ul class="detail_panel" v-for="(group, key) in App.query.getFilters()" :key="key">
                        <li v-if="group.length > 0">
                            <label>{{
                                translations.categories[filters_families[key]]
                            }}</label>
                            <ul>
                                <li v-for="(filter, index) in group" :key="index">
                                    {{ filter.text }}
                                </li>
                            </ul>
                        </li>
                    </ul> -->
                    <ul class="detail_panel" v-for="(values, key) in App.query.getFilters()" :key="key">
                        <li v-if="key != 'language' && key != 'market' && values.length > 0">
                            <label>{{
                                App.translations.categories[
                                    App.query.valid_keys[key]
                                ][App.selected_language]
                            }}</label>
                            <ul>
                                <li v-for="(filter, index) in values" :key="index">
                                    {{ App.entities[App.query.valid_keys[key]][filter][App.selected_language] }}
                                </li>
                            </ul>
                        </li>
                    </ul>
                </article>
            </span>
        </section>
    </div>
</template>

<script>
import $ from 'jquery'
import App from './../application.js'

export default {
    data: function () {
        // TODO: veure que fa aixo aqui a l'esquerra
        var filters_selected = App.query.getSelectedFilters(App.unex_lib.active_filters);
        return {
            unex_lib: App.unex_lib,
            password: '',
            new_password: '',
            new_password2: '',
            selected_market_solutions: App.selected_market_solutions,
            selected_language: App.selected_language,
            markets: App.entities.markets,
            is_debug_mode: this.$root.$data.is_debug_mode,
            user: App.user,
            translations: App.current_translations,
            App: App,
            errors_profile: {
                empty_field: false,
                not_equal_passwords: false,
                not_correct_format_passwords: false
            },
            show_change_my_password: false,
            password_visible: false,
            profile_active: false,
            query_details_active: false,
            lateral_menu_items: App.filterInCurrentView(
                App.lateral_menu_items,
                App.root_activated_view
            ),
            filters_selected: filters_selected,
            filters_families: Object.keys(App.unex_lib.active_filters),
            total_filters_selected: App.query.getTotalSelected()
        }
    },
    mounted: function () {
        App.bus.$on('change_menu_items', (function (value) {
            this.lateral_menu_items = value;
        }).bind(this));
        App.bus.$on('update_active_filters', (function () {
            this.filters_selected = App.query.getSelectedFilters(App.unex_lib.active_filters);
            this.filters_families = Object.keys(App.unex_lib.active_filters);
            this.total_filters_selected = App.getTotalFiltersSelected(this.filters_selected);
        }).bind(this));
        App.bus.$on('saveChangeLanguageApp', (function () {
            this.selected_language = App.selected_language;
        }).bind(this));
    },
    methods: {
        openPanelProfile: function () {
            this.profile_active = this.profile_active == false;
            if (this.query_details_active == true) {
                this.query_details_active = false;
            }
            $('a.user_profile').toggleClass('opened');
        },
        openPanelQueryDetails: function () {
            this.query_details_active = this.query_details_active == false;
            if (this.profile_active == true) {
                this.profile_active = false;
            }
        },
        openLanguageModal: function () {
            App.bus.$emit('modal_language');
        },
        openMarketModal: function () {
            App.bus.$emit('modal_market');
        },
        closeSession: function () {
            App.bus.$emit('modal_logout', { is_visible: true });
        },
        selectedMenuItem: function (item) {
            if (item.hasView == true) {
                if (item.value === "dashboard") {
                    App.bus.$emit('is_clean_query_dashboard');
                }
                // this.$root.$data.root_activated_view
                switch (item.value) {
                    case 'dashboard':
                        this.$router.push('/')

                        break;

                    default:
                        break;
                }
                // App.root_activated_view = item.value;
            } else {
                if (typeof this[item.fnc] === "function") {
                    this[item.fnc].call(this);
                }
            }
        },
        showPasswordCharts: function (className) {
            var classNameCollection = document.querySelectorAll(className);
            if (classNameCollection != null && classNameCollection != '') {
                if (this.password_visible == true) {
                    this.password_visible = false;
                    for (var i = 0; i < classNameCollection.length; i++) {
                        var el = classNameCollection[i];
                        el.type = 'password';
                    }
                } else {
                    this.password_visible = true;
                    for (var i1 = 0; i1 < classNameCollection.length; i1++) {
                        var el1 = classNameCollection[i1];
                        el1.type = 'text';
                    }
                }
            }
        },
        updatePassword: function () {
            if (this.password != '' && this.new_password != '' && this.new_password2 != '') {
                var self = this;
                if (this.new_password === this.new_password2) {
                    var result = App.unex_lib.updateUserData({ password: this.password, new_password: this.new_password2 }, function () {
                        var x = JSON.parse(this.response);
                        self.errors_profile.empty_field = false;
                        self.errors_profile.not_equal_passwords = false;
                        self.errors_profile.not_correct_format_passwords = true;
                    });
                    if (result.hasOwnProperty('id')) {
                        self.profile_active = false;
                        self.password = "";
                        self.new_password = "";
                        self.new_password2 = ""
                        self.password_visible = false;
                    }
                } else if (this.new_password !== this.new_password2) {
                    this.errors_profile.empty_field = false;
                    this.errors_profile.not_equal_passwords = true;
                } else {
                    this.errors_profile.not_equal_passwords = false;
                    this.errors_profile.empty_field = false;
                    this.profile_active = false;
                    this.password = "";
                    this.new_password = "";
                    this.new_password2 = "";
                    this.show_change_my_password = false;
                    this.password_visible = false;
                }
            } else {
                this.errors_profile.empty_field = true;
            }
        }
    }
}
</script>

<style></style>